<div :class="className" class="row txt-center">
  <div :style="sizes" class="loader"></div>
  <div v-show="isLoading" class="col-12 mt10 txt-center loading-footer">
    <div class="pl10 letter-spacing">{{ $t(textLoading) }}</div>
    <div class="loading-dot" style="color: var(--black-light);">&#8226;&#8226;&#8226;</div>
  </div>
</div>
